import { TicketRepository } from '../repositories/TicketRepository'

export function ListOperationalAreasCase(ticketRepository: TicketRepository) {
  return async function ({ operationalId }: { operationalId: string }) {
    return await ticketRepository.listOperationalAreas({ operationalId })
  }
}
